import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoutesHistoricService {

  private routes = new Array<String>();

  constructor(private router: Router) { }

  public init() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.routes.push(event.url);
      }
    });
  }

  public getPreviousUrl() {
    return this.routes[this.routes.length - 2];
  }
}
